/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_PermissionsInputs */

const en_tables_skill_groups_permissions = /** @type {(inputs: Tables_Skill_Groups_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Permissions`)
};

const de_tables_skill_groups_permissions = /** @type {(inputs: Tables_Skill_Groups_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen`)
};

/**
* | output |
* | --- |
* | "Groups Permissions" |
*
* @param {Tables_Skill_Groups_PermissionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_permissions = /** @type {((inputs?: Tables_Skill_Groups_PermissionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_PermissionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_permissions(inputs)
	return de_tables_skill_groups_permissions(inputs)
});